module.exports = function getResource(label, vars = []) {
    let resources = {
        createANickname: '[ Create a nickname ]',
        tapToSee: 'Tap to see',
        clickToSee: 'Click to see',
        thisMembersFollowers: 'this member’s followers and who they’re following!',
        following: 'following',
        follower: 'follower',
        followers: 'followers',
        gotIt: 'Got it',
        userProfileMessage: `<b>${vars[0] ? 'Tap' : 'Click'} to see</b> your followers and who you’re following!`,
        otherUserProfileMessage: `<b>${vars[0] ? 'Tap' : 'Click'} to see</b> this member’s followers and who they’re following!`
    };
    return resources[label];
};
